import { render, staticRenderFns } from "./cursos-barra.vue?vue&type=template&id=881ca66c&scoped=true&"
import script from "./cursos-barra.vue?vue&type=script&lang=ts&"
export * from "./cursos-barra.vue?vue&type=script&lang=ts&"
import style0 from "./cursos-barra.vue?vue&type=style&index=0&id=881ca66c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881ca66c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSpacer})
